"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _accommodation = _interopRequireDefault(require("./accommodation"));
var _artsEntertainment = _interopRequireDefault(require("./arts-entertainment"));
var _automobile = _interopRequireDefault(require("./automobile"));
var _groundTransfer = _interopRequireDefault(require("./ground-transfer"));
var _default = exports["default"] = {
  accommodation: _accommodation["default"],
  artsEntertainment: _artsEntertainment["default"],
  automobile: _automobile["default"],
  groundTransfer: _groundTransfer["default"]
};